import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-policy-transactions",
  "use": "gw-policy-transactions-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-policy-transactions\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M5.15 12.86c.31-.32.85-.1.85.35V15h14c.55 0 1 .45 1 1l-.01.11c-.06.49-.49.88-1 .88h-14v1.79c0 .45-.54.67-.86.35l-2.79-2.79a.492.492 0 0 1 .01-.7ZM18 5.21c0-.45.54-.67.86-.35l2.79 2.79c.19.19.19.51-.01.7l-2.79 2.79c-.31.32-.85.1-.85-.35V9H4c-.55 0-1-.45-1-1v-.12c.05-.5.48-.89.99-.89h14Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol